import { ReactNode, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import BottomNavigation from "./BottomNavigation";
import { useAuth } from "@/contexts/UnifiedAuthContext";
// import { useProfile } from "@/hooks/useProfile";
import { EditingStateProvider } from "@/contexts/EditingStateContext";
// import LeadQualificationModal from "@/components/common/LeadQualificationModal";

interface MainLayoutProps {
  children: ReactNode;
  onBackClick?: () => void;
  showBackButton?: boolean;
  disabled?: boolean;
}

const MainLayout = ({ children, onBackClick, showBackButton, disabled = false }: MainLayoutProps) => {
  const { user, status } = useAuth();
  // const { profile, isLoading } = useProfile(user?.id);
  // const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);
  // const [leadFormCompleted, setLeadFormCompleted] = useState(false);
  const location = useLocation();

  // Список путей, где BottomNavigation не должен отображаться
  const authPaths = [
    "/login",
    "/register",
    "/email-confirmation",
    "/forgot-password",
    "/registration-confirmation",
    "/reset-password",
  ];

  const shouldShowBottomNavigation = !authPaths.includes(location.pathname);

  // useEffect(() => {
    // Проверяем sessionStorage при каждом монтировании
    // const sessionCompleted = sessionStorage.getItem(`lead_form_completed_${user?.id || "unknown"}`) === "true";

    // Отладочная информация
    // console.log("🚀 [MainLayout Debug] Auth status:", status);
    // console.log("🚀 [MainLayout Debug] User:", user);
    // console.log("🚀 [MainLayout Debug] Profile loading:", isLoading);
    // console.log("🚀 [MainLayout Debug] Profile data:", profile);
    // console.log("🚀 [MainLayout Debug] Lead form completed locally:", leadFormCompleted);
    // console.log("🚀 [MainLayout Debug] Session storage completed:", sessionCompleted);

    // Если в sessionStorage есть флаг завершения, обновляем локальное состояние
    // if (sessionCompleted && !leadFormCompleted) {
    //   setLeadFormCompleted(true);
    //   return;
    // }

    // Проверяем нужно ли показать форму квалификации лида
  //   if (status === "authenticated" && user && !isLoading && profile && !leadFormCompleted && !sessionCompleted) {
  //     const profileWithForm = profile as { lead_form_completed?: boolean };
  //     const shouldShowLeadForm = !profileWithForm.lead_form_completed;

  //     console.log("🚀 [MainLayout Debug] lead_form_completed:", profileWithForm.lead_form_completed);
  //     console.log("🚀 [MainLayout Debug] Should show lead form:", shouldShowLeadForm);

  //     if (shouldShowLeadForm) {
  //       console.log("🚀 [MainLayout Debug] Opening lead qualification modal...");
  //       setIsLeadFormOpen(true);
  //     }
  //   }
  // }, [status, user, profile, isLoading, leadFormCompleted]);

  // const handleLeadFormClose = (formCompleted: boolean = false) => {
  //   console.log("🚀 [MainLayout Debug] handleLeadFormClose called with formCompleted:", formCompleted);
  //   setIsLeadFormOpen(false);
  //   if (formCompleted) {
  //     setLeadFormCompleted(true);
  //     // Сохраняем в sessionStorage с ключом пользователя
  //     try {
  //       const key = `lead_form_completed_${user?.id || "unknown"}`;
  //       sessionStorage.setItem(key, "true");
  //       console.log("🚀 [MainLayout Debug] Saved to sessionStorage with key:", key);
  //     } catch (error) {
  //       console.warn("Could not save to sessionStorage:", error);
  //     }
  //   }
  // };

  return (
    <EditingStateProvider>
      <div className="flex flex-col min-h-screen">
        <Header onBackClick={onBackClick} showBackButton={showBackButton} disabled={disabled} />
        <main className="flex-1 pb-16 md:pb-0">{children}</main>
        <Footer />

        {/* Bottom Navigation - показывается только на мобильных устройствах */}
        {shouldShowBottomNavigation && <BottomNavigation />}

        {/* Форма квалификации лида */}
        {/* <LeadQualificationModal open={isLeadFormOpen} onOpenChange={handleLeadFormClose} /> */}
      </div>
    </EditingStateProvider>
  );
};

export default MainLayout;
